module.exports = __webpack_public_path__ + "img/1.169f9915.svg";